import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 90 90",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 90 90\" id=\"plus\">\n  <path fill-rule=\"evenodd\" d=\"M47 9a2 2 0 1 0-4 0v34H9a2 2 0 1 0 0 4h34v34a2 2 0 1 0 4 0V47h34a2 2 0 1 0 0-4H47V9Z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol